module.exports = __webpack_public_path__ + "img/demo-booking.3e6e08c2.webp";